import useSWR, { SWRResponse } from "swr";
import { IUsePortalMessage } from "./types";
import { IPortalMessage } from "@portal/types/api/IPortalMessage";
import commonSwrConfig from "../commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";

const usePortalMessage: IUsePortalMessage = () => {
  const { update } = useSession();

  const { data, error, isLoading }: SWRResponse<IPortalMessage, string> = useSWR(
    `/api/portal/message`,
    commonFetcher<IPortalMessage>,
    commonSwrConfig(update),
  );

  return {
    data,
    error,
    isLoading,
  };
};

export default usePortalMessage;
